/**
 * External dependencies
 */
import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';
import {
  Card,
  CardDescription,
  CardFooter,
  CardHeader,
} from '@art-of-hospitality-solutions-llc/ui-kit/components/card';
import { Heading } from '@art-of-hospitality-solutions-llc/ui-kit/components/heading';
import Breadcrumbs from '@Components/Breadcrumbs';
import { Link } from 'react-router-dom';

export default function Locations() {
  return (
    <div className="w-full">
      <Breadcrumbs navList={[{ name: 'Locations', href: '/locations' }]} />
      <div className="mt-8 mb-4 flex items-center justify-between">
        <div>
          <Heading>Location Management</Heading>
          <p>Manage the venues and spaces within your organization.</p>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
        <Card className="h-full">
          <CardHeader>
            <Heading level="h2">Venues</Heading>
            <CardDescription>
              Manage your venues and their details.
            </CardDescription>
          </CardHeader>
          <CardFooter>
            <Button asChild>
              <Link to="/venues">Manage Venues</Link>
            </Button>
          </CardFooter>
        </Card>
        <Card className="h-full">
          <CardHeader>
            <Heading level="h2">Spaces</Heading>
            <CardDescription>
              Manage your spaces and their details.
            </CardDescription>
          </CardHeader>
          <CardFooter>
            <Button asChild>
              <Link to="/spaces">Manage Spaces</Link>
            </Button>
          </CardFooter>
        </Card>
      </div>
    </div>
  );
}
